// extracted by mini-css-extract-plugin
export default {"brandFilter":"QNS4ImmZFf1siTlu0igV-BrandFilter-brandFilter","brandFilter__title":"IF260rTZHA8SPlUXo0gQ-BrandFilter-brandFilter__title"};